module.exports = __webpack_public_path__ + "static/media/LG-bg.2e6a3e3e.png";